import React from 'react'
import {
    Form,
    Input,
    Button,
    Row,
    Col,
    Divider,
    Select,
    Spin,
    Table,
    notification,
    // Icon,
} from 'antd';
import debounce from 'lodash/debounce'
import API from '../../../services/API'

// eslint-disable-next-line prefer-destructuring
const Option = Select.Option

// eslint-disable-next-line no-unused-vars
function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

const getRandomId = (length) => {
    let result = '';
    // eslint-disable-next-line prefer-const
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    // eslint-disable-next-line prefer-const
    let charactersLength = characters.length;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

class InventoryEntryForm extends React.Component {
    constructor(props) {
        super(props);
        this.getWarehouses = debounce(this.getWarehouses, 800)
        this.getProducts = debounce(this.getProducts, 800)
        this.getSubsidiaries = debounce(this.getSubsidiaries, 800)
    }

    // eslint-disable-next-line react/state-in-constructor
    state = {
        data: {},

        subsidiarie_id: {
            key: '',
            label:''
        },
        warehouse_id: {
            key: '',
            label: '',
        },
        product_id: {
            key: '',
            label: '',
        },
        measure_unit_id: {
            key: '',
            label: '',
        },
        subsidiaries: {
			data: [],
			loading: false,
        },
        warehouses: {
			data: [],
			loading: false,
        },
        products: {
			data: [],
			loading: false,
        },
        measureUnits: {
			data: [],
			loading: false,
        },
        productsToWarehouse: [],
        productsToWarehouseIds: [],
        warehouseSearch: '',
    }

    componentDidMount() {
        // To disabled submit button at the beginning.
        if (this.props.fields && this.props.fields.name) {
            this.props.form.setFields({
                ...this.props.fields,
            });
            this.props.form.validateFields();
        }
        this.getAdittionalData();
    }

    getAdittionalData = () => {
        this.setState({
            measureUnits: {
                data: [],
                loading: false,
            },
        });
        API.get('/api/measure_units?pagination=false')
            .then((response) => {
             
                this.setState({
                    measureUnits: {
                        data: response.data.map(g => ({
                            value: g.id,
                            text: g.name,
                        })),
                        loading: true,
                    },
                });
            })
            .catch((err) => {
                console.error('Estos son los erores');
                console.error(err);
            });
        this.getResourceTypeahead(
            'warehouses',
            '/api/warehouses',
            // `/api/warehouses?filter[subsidiary_id]=${this.state.subsidiarie_id.key}`,
            (warehouse) => ({
                text: warehouse.name,
                value: warehouse.id,
            }),
        )
    }

    handleSubmit = (e) => {
        e.preventDefault();
        // validamos los valores y se los mandamops al padre para que los guarde
        // eslint-disable-next-line no-unused-vars
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { getValues,setValues } = this.props;
                if (getValues) {
                    getValues(this.state.productsToWarehouse);
                }
            }
            // else {}
        });
    }

    getResourceTypeahead = async (resource, uri, stateCallback) => {
		try {
			await this.setState({
				[resource]: {
					// eslint-disable-next-line react/no-access-state-in-setstate
					...this.state[resource],
					loading: true,
				},
			})
            const response = await API.get(uri)
			this.setState({
				[resource]: {
					data: response.data.data.map(stateCallback),
					loading: false,
				},
			})
		} catch (error) {
			this.setState({
				[resource]: {
					data: [],
					loading: false,
				},
            })
		}
    }

    getSubsidiaries = (search) => {
		this.getResourceTypeahead(
			'subsidiaries',
			`/api/subsidiaries?filter[name]=${search}`,
			(subsidiarie) => ({
				text: `${subsidiarie.name}`,
				value: subsidiarie.id,
			}),
		)
    }

    // eslint-disable-next-line consistent-return
    getWarehouses = (search) => {
        const { subsidiarie_id } = this.state;
        if (subsidiarie_id.key === '') {
            notification.open({
                message: 'Primero debe seleccionar una sucursal.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            });
            return null;
        }
		this.getResourceTypeahead(
			'warehouses',
			`/api/warehouses?filter[name]=${search}&filter[subsidiarie_id]=${subsidiarie_id.key}`,
			(warehouse) => ({
				text: `${warehouse.name}`,
				value: warehouse.id,
			}),
		)
    }

    // eslint-disable-next-line consistent-return
    getProducts = (search) => {
        if(!search.length){
            return false
        }
        const {
            warehouse_id,
            // subsidiarie_id
            // productsToWarehouse
        } = this.state;
        if (warehouse_id.key === '') {
            notification.open({
                message: 'Primero debe seleccionar una bodega.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            });
            return null;
        }

        // if (subsidiarie_id.key === '') {
        //     notification.open({
        //         message: 'Primero debe seleccionar una sucursal.',
        //         // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
        //     });
        //     return null;
        // }
        // eslint-disable-next-line prefer-const
        let query = '';
        /** Esto es para hacer que no se repitan los productos que ya ingresaste */
        // let productsIds = productsToWarehouse.map(g => g.product_id.key);
        // for (let index = 0; index < productsIds.length; index++) {
        //     const item = productsIds[index];
        //     query = `${query}&notIn[]=${item}`;
        // }
        let filter=''
        
        let queryCustom = Number(search)

        
        if(!isNaN(queryCustom)){
            filter+=`&filter[barcode]=${search}`
        }else{
            filter+=`filter[name]=${search}&filter[sku]=${search}`
        }
		this.getResourceTypeahead(
			'products',
			`/api/only/products?${filter}
            &include[]=currency&include[]=brand&include[]=productType&include[]=measureUnit${query}`,
			(product) => ({
				text: `${product.name}`,
                value: product.id,
			}),
		)
	}

    handleSelectChange = (name) => (value) => {
		this.setState({
            [name]: value,
			// data: {
			// 	...this.state.data,
			// 	[name]: value
			// }
		})
    }

    /* Lo dejamos preparado para agregar el measure_unit de forma de
    preview de lo que se ingresara no como manera funcional */
    handleProductChange = (value) => {
        this.setState({
            product_id: value,
            // measure_unit_id: {
            //     key: value.measure_unit.id,
            //     value: value.measure_unit.name,
            // }
		})
    }

    handleSelectSubsidiarieChange = (value) => {
        this.setState({
            subsidiarie_id: value,
            warehouses: {
                data: [],
                loading: false,
            },
            products: {
                data: [],
                loading: false,
            },
            warehouse_id: {
                key: '',
                label: '',
            },
            product_id: {
                key: '',
                label: '',
            },
            productsToWarehouse: [],
        })
        this.getResourceTypeahead(
			'warehouses',
			`/api/warehouses?filter[subsidiary_id]=${value.key}`,
			(warehouse) => ({
				text: `${warehouse.name}`,
				value: warehouse.id,
			})
		)
    }

    handleSelectWarehouseChange = (value) => {

        console.log(value,'value')

        this.setState({
            warehouse_id: value,
            products: {
                data: [],
                loading: false,
            },
            // product_id: {
            //     key: '',
            //     label: ''
            // },
            productsToWarehouse: [],
        })
        // this.getResourceTypeahead(
		// 	'products',
		// 	`/api/products?filter[warehouse_id]=${value.key}`,
		// 	product => ({
		// 		text: `${product.name}`,
		// 		label: product.id
		// 	})
		// )
    }

    // eslint-disable-next-line consistent-return
    addToWarehouse = () => {
        const {
            subsidiarie_id,
            warehouse_id,
            product_id,
            // measure_unit_id,
            productsToWarehouse,
            productsToWarehouseIds,
        } = this.state;
        const {
            getFieldValue,
        } = this.props.form;
     /*   if (subsidiarie_id.key === '') {
            notification.error({
                message: 'Primero debe seleccionar una sucursal.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            });
            return null;
        }
        */
        if (warehouse_id.key === '') {
            notification.error({
                message: 'Primero debe seleccionar una bodega.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            });
            return null;
        }
        if (product_id.key === '') {
            notification.error({
                message: 'Primero debe seleccionar una producto.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            });
            return null;
        }
        // if (measure_unit_id.key === '') {
        //     notification.error({
        //         message: 'Debe seleccionar una unidad de medida.',
        //         // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
        //     });
        //     return null;
        // }
        const quantity = getFieldValue('quantity');
        if (!quantity || quantity <= 0) {
            notification.error({
                message: 'Cantidad de productos invalida.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            });
            return null;
        }
        if (productsToWarehouse.filter(g => g.product_id.key === product_id.key).length > 0) {
            notification.error({
                message: 'El producto ya esta agregado en la lista.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            });
            return null;
        }
        // eslint-disable-next-line prefer-const
        let tempProductsToWarehouse = JSON.parse(JSON.stringify(productsToWarehouse));
        // eslint-disable-next-line prefer-const
        let tempProductsToWarehouseIds = JSON.parse(JSON.stringify(productsToWarehouseIds));
        tempProductsToWarehouse.push({
            uid: getRandomId(8),
            // subsidiarie_id,
            target_warehouse_id: warehouse_id,
            product_id,
            quantity,
        });
        tempProductsToWarehouseIds.push(product_id.key);

        this.setState({
            productsToWarehouse: tempProductsToWarehouse,
            productsToWarehouseIds: tempProductsToWarehouseIds,
            product_id: {
                key: '',
                label: '',
            },
            measure_unit_id: {
                key: '',
                label: '',
            },
        });
    }

    removeProductFromWarehouse = (uid, product_id) => {
        const { productsToWarehouse, productsToWarehouseIds } = this.state;
        // eslint-disable-next-line prefer-const
        let tempProductsToWarehouse = JSON.parse(JSON.stringify(productsToWarehouse));
        // eslint-disable-next-line prefer-const
        let tempProductsToWarehouseIds = JSON.parse(JSON.stringify(productsToWarehouseIds));

        const newProductsToWarehouse = tempProductsToWarehouse.filter(g => g.uid !== uid);
        const newProductsToWarehouseIds = tempProductsToWarehouseIds.filter(g => g !== product_id);
        this.setState({
            productsToWarehouse: newProductsToWarehouse,
            productsToWarehouseIds: newProductsToWarehouseIds,
        });
    }

    render() {
        const {
            getFieldDecorator,
            getFieldError,
            isFieldTouched,
            // getFieldsError,
        } = this.props.form;

        // Only show error after a field is touched.
        const quantityError = isFieldTouched('quantity') && getFieldError('quantity');
        // const nameError = isFieldTouched('name') && getFieldError('name');
        // const descriptionError = isFieldTouched('description') && getFieldError('address');
        // const filteredOptions = this.state.subsidiaries.data.filter(o => !selectedItems.includes(o));

        const columns = [{
            title: 'Producto',
            dataIndex: 'product_id',
            key: 'product_id',
            render: (label, record) => record.product_id.label,
        }, {
            title: 'Cantidad',
            dataIndex: 'quantity',
            key: 'quantity',
        }, {
            title: 'Order',
            dataIndex: 'order_id',
            key: 'order_id',
            // render: (label, record) => record.product_id.label,
        }, {
            title: 'Bodega destino',
            dataIndex: 'target_warehouse_id',
            key: 'target_warehouse_id',
            render: (label, record) => record.target_warehouse_id.label,
        }, {
            title: 'Acción',
            dataIndex: '',
            key: 'action',
            render: (label, record) => (
                <div key={record.uid}>
                    <Button
                        type="danger"
                        shape="circle"
                        icon="delete"
                        size="small"
                        onClick={() => this.removeProductFromWarehouse(record.uid, record.product_id.key)}
                    />
                </div>
            ),
        }];

        return (
            <>
                <Form>
                    <Row gutter={16}>
                        {/* <Col lg={8} md={18} sm={24}>
                            <Form.Item label="Sucursal">
                                <Select
                                    showSearch
                                    labelInValue
                                    value={this.state.subsidiarie_id}
                                    placeholder="Busca una sucursal"
                                    notFoundContent={
                                        this.state.subsidiaries
                                            .loading ? (
                                            <Spin size="small" />
                                        ) : (
                                            'No hay resultados'
                                        )
                                    }
                                    filterOption={false}
                                    onSearch={this.getSubsidiaries}
                                    onChange={this.handleSelectSubsidiarieChange}
                                    style={{ width: '100%' }}
                                >
                                    {this.state.subsidiaries.data.map(
                                        d => (
                                            <Option key={d.value}>
                                                {d.text}
                                            </Option>
                                        )
                                    )}
                                </Select>
                            </Form.Item>
                        </Col> */}
                        <Col lg={8}>
                            <Form.Item label="Bodega">
                                <Select
                                    showSearch
                                    labelInValue
                                    value={this.state.warehouse_id}
                                    placeholder="Busca una bodega"
                                    notFoundContent={
                                        this.state.warehouses
                                            .loading ? (
                                            <Spin size="small" />
                                        ) : (
                                            'No hay resultados'
                                        )
                                    }
                                    disabled={this.state.productsToWarehouse.length !== 0}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onChange={this.handleSelectWarehouseChange}
                                    style={{ width: '100%' }}
                                >
                                    {this.state.warehouses.data.map(
                                        (d) => (
                                            <Option key={d.value}>
                                                {d.text}
                                            </Option>
                                        ),
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col lg={8}>
                            <Form.Item label="Producto">
                                <Select
                                    showSearch
                                    labelInValue
                                    value={this.state.product_id}
                                    placeholder="Busca un producto"
                                    notFoundContent={
                                        this.state.products
                                            .loading ? (
                                            <Spin size="small" />
                                        ) : (
                                            'No hay resultados'
                                        )
                                    }
                                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onChange={this.handleProductChange}
                                    filterOption={false}
                                    onSearch={this.getProducts}
                                    // onChange={this.handleSelectChange(
                                    //     'product_id'
                                    // )}
                                    style={{ width: '100%' }}
                                >
                                    {this.state.products.data.map(
                                        // eslint-disable-next-line arrow-body-style
                                        (d) => {
                                            // Es una validacion para que no se repitan los productos seleccionados
                                            // if (this.state.productsToWarehouseIds.includes(d.value.toString())) {
                                            //     return null;
                                            // }
                                            return (
                                                <Option key={d.value}>
                                                    {d.text}
                                                </Option>
                                            )
                                        },
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col lg={3}>
                            <Form.Item label="Unidad de Medida">
                                <Select
                                    disabled
                                    showSearch
                                    labelInValue
                                    value={this.state.measure_unit_id}
                                    placeholder="Busca una Unidad de Medida"
                                    notFoundContent={
                                        this.state.measureUnits
                                            .loading ? (
                                            <Spin size="small" />
                                        ) : (
                                            'No hay resultados'
                                        )
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    // onChange={value => this.setState({ measure_unit_id: value })}
                                    style={{ width: '100%' }}
                                >
                                    {this.state.measureUnits.data.map(
                                        d => (
                                            <Option key={d.value}>
                                                {d.text}
                                            </Option>
                                        )
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col lg={3}>
                            <Form.Item
                                label="Cantidad"
                                validateStatus={quantityError ? 'error' : 'success'}
                                help={quantityError || ''}
                                hasFeedback
                            >
                                {getFieldDecorator('quantity', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Es necesario insertar una cantidad',
                                        },
                                    ],
                                })(
                                    <Input
                                        placeholder="Cantidad"
                                        type="number"
                                        // eslint-disable-next-line comma-dangle
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col
                            lg={2}
                            style={{
                                paddingLeft: 10,
                            }}
                        >
                            <br />
                            <br />
                            <Button
                                type="primary"
                                shape="circle"
                                icon="plus"
                                onClick={this.addToWarehouse}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <br />
                    </Row>
                    <Row>
                        <Table
                            dataSource={this.state.productsToWarehouse}
                            columns={columns}
                            rowKey="uid"
                        />
                    </Row>
                </Form>
                <Divider />
                <Row type="flex" justify="center">
                    <Col>
                        <Button
                            type="primary"
                            size="large"
                            icon="save"
                            disabled={this.state.productsToWarehouseIds.length === 0}
                            onClick={this.handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Col>
                </Row>
            </>
        );
    }
}

const WrappedInventoryEntryForm = Form.create({ name: 'InventoryEntryVerticalForm' })(InventoryEntryForm);
export default WrappedInventoryEntryForm;
